<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FF9933">
        <v-card-title>
          <v-icon large left>mdi-excavator</v-icon>
          <h6>Obra - Recepción de Materiales con remito</h6>
           
        </v-card-title>
        
          <!-- <v-row
          dense
          align="center"
          justify="end"
        >
          <v-icon
          @click="buscarMate()">
           mdi-format-list-bulleted-square
          </v-icon>
          <span class="subheading mr-2">Buscar Material</span>
          </v-row> -->
        
        <v-card-text>
          <v-row dense>
            <v-col cols="6" sm="6" md="6" align-self="center">
              <v-combobox
                dense
                v-model="comboot"
                :items="numot"
                label="Seleccione N° OT"
                item-text="detalle"
                item-value="otrabajo"
                @change="cargarListado(comboot.otrabajo, '', '', '1')"
              ></v-combobox>
            </v-col>
            
            <!-- <v-col cols="12" sm="2" md="3">
  <v-switch
      v-model="otactivas"
      :label="'Sólo OT activas'"
      @change="cargarOT()"
    ></v-switch>
</v-col> -->
          </v-row>
          <v-row dense>
            <v-col cols="8" sm="8" md="8" align-self="center">
              <v-combobox
                dense
                label="Seleccione la obra"
                v-model="comboobra"
                :items="obra"
                item-text="nombre"
                item-value="gasto"
                @change="cargarRemito(comboobra.gasto)"
              ></v-combobox>
            </v-col>
            <v-col cols="4" sm="4" md="4" align-self="center">
              <v-combobox
                dense
                label="Seleccione remito ICSSA"
                v-model="comboremito"
                :items="remitos"
                item-text="numero"
                item-value="numero"
                @change="
                  cargarListado('', comboremito.numero, 'REMITO INTERNO', '2')
                "
              ></v-combobox>
            </v-col>

            <v-col cols="12" sm="12" md="6" align-self="center">
              <v-text-field
                label="Igrese el N° de Nota de Pedido de ICSSA"
                dense
                v-model="notapedido"
                @keyup.enter="cargarListado('', '', '', '3')"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <CargaRemito
        :visible="showCarga"
        :numot="this.numeroot"
        :remito="this.remito"
        :proveedor="this.proveedor"
        :npedido="this.notapedido"
        :flag="this.flag"
        @close="showCarga = false"
      ></CargaRemito>
      <!-- <Buscarmate
        :visible="showBuscar"
        @close="showBuscar = false"
      ></Buscarmate> -->
    </v-app>
  </div>
</template>



<script>
import axios from "../../../src/axios-auth";
import CargaRemito from "../Obras/CargaRemito.vue";
export default {
  data: (vm) => ({
    otactivas: true,
    comboot: "",
    numot: [],
    comboobra: "",
    obra: [],
    comboremito: "",
    remitos: [],
    notapedido: "",
    showCarga: false,
    showBuscar: false,
    numeroot: "",
    remito: "",
    proveedor: "",
    editedItem: {},
    editedIndex: -1,
    flag: "",
  }),

  computed: {
    show: {
      get() {
        this.cargarOT();
        this.cargarObra();
        return this.visible;
      },
      set(value) {
        if (!value) {
          //this.$refs.form.resetValidation();
          //this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  //   watch: {
  //   numot: function (val) {
  //       this.numeroot = this.numot.codgral
  //     },
  // },
  components: { CargaRemito },
  methods: {
    cargarOT() {
      let self = this;
      axios
        .get("/Obras/GetOT?")
        .then((response) => {
          self.numot = response.data;
        })
        .catch((error) => {
          self.numot = [];
          console.log(error);
        });
    },

    cargarObra() {
      let self = this;
      axios
        .get("/Obras/GetObras?")
        .then((response) => {
          self.obra = response.data;
        })
        .catch((error) => {
          self.obra = [];
          console.log(error);
        });
    },

    cargarRemito(codigo) {
      let self = this;
      axios
        .get("/Obras/GetRemito?", {
          params: {
            codigo: codigo,
          },
        })
        .then((response) => {
          self.remitos = response.data;
        })
        .catch((error) => {
          self.remitos = [];
          console.log(error);
        });
    },
    cargarListado(otrabajo, numremito, codproveedor, bandera) {
      this.numeroot = otrabajo;
      this.remito = numremito;
      this.proveedor = codproveedor;
      this.flag = bandera;
      this.showCarga = true;
      console.log("numot:" + this.numeroot);
    },
    // buscarMate() {
    //  this.showBuscar=true;
    // },
  },
};
</script>